import { scopeClassName } from './scopeClassName.js';
import { replaceAllDots } from './stringFormatter.js';

var _ = ' ';

/* eslint-disable no-param-reassign */
var cx = function cx(classNamesArray, screen) {
  return classNamesArray.reduce(function (classNames, className) {
    if (!className) return classNames;
    classNames += (screen !== false ? scopeClassName((screen ? "".concat(screen, ":") : '') + className) : className) + _;
    return classNames;
  }, '');
};
var toCx = function toCx(utility, token) {
  if (!token) return undefined;
  return token.indexOf('-') === 0 ? "-".concat(utility, "-").concat(replaceAllDots(token.substr(1))) : "".concat(utility, "-").concat(replaceAllDots(token));
};
var toCxn = function toCxn(utility, tokens, subscript, none) {
  var screen = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var skipScope = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (!tokens) return '';
  var prefix = screen && "".concat(screen, ":");
  if (typeof tokens === 'string') return !skipScope ? scopeClassName(prefix + toCx(utility, tokens)) : prefix + toCx(utility, tokens);
  return subscript.reduce(function (classNames, key, index) {
    var token = tokens[index];
    if (!token && none === false) return classNames;
    var cName = "".concat(prefix).concat(utility, "-").concat(key, "-").concat(token || none || '0');
    return classNames + (!skipScope ? scopeClassName(cName) : cName) + _;
  }, '');
};

export { _, cx, toCx, toCxn };
//# sourceMappingURL=classname.js.map
